import { useSyncExternalStore } from 'react';
import { getToken, subscribeToToken } from './api';

/**
 * The current session token, as React state.
 *
 * `useSyncExternalStore` is the right primitive here: the token lives outside
 * React (it is read by the fetch layer and can be cleared by a 401 on any
 * request), and every component that depends on it must re-render when it
 * changes. Reading the module variable directly during render is what makes
 * sign-in silently fail to update the page.
 */
export function useSession(): string | null {
  return useSyncExternalStore(subscribeToToken, getToken, getToken);
}
